export const FROM_PAVE = 'FROM_PAVE';
export const IMG_PHOTOBAR = 'IMG_PHOTOBAR';
export const SET_MESSAGES = 'SET_MESSAGES';
export const SHOW_PHOTOBAR = 'SHOW_PHOTOBAR';
export const HIDE_PHOTOBAR = 'HIDE_PHOTOBAR';
export const RESET_PHOTOBAR = 'RESET_PHOTOBAR';
export const CONCAT_IMG_GALLERY = 'CONCAT_IMG_GALLERY';
